import { OrderID } from '@/contexts/automaticPrint/types'
import { ActiveOrder } from '@/resources/types'

export const AUTOMATIC_PRINT_STORAGE_KEY = 'AUTOMATIC_PRINT'
export const PRINT_HISTORY_STORAGE_KEY = 'PRINT_ORDER_HISTORY'

export const getIsAutomaticPrintEnabledValue = (): boolean =>
  localStorage.getItem(AUTOMATIC_PRINT_STORAGE_KEY) === 'true'

export const setAutomaticPrintEnabledValue = (isEnabled: boolean): void => {
  localStorage.setItem(AUTOMATIC_PRINT_STORAGE_KEY, String(isEnabled))
}

export const findNotPrintedOrders = (
  orders: Array<ActiveOrder>
): Array<ActiveOrder> => {
  const printHistory = getPrintHistory()
  return orders.filter(({ number }) => !printHistory.includes(String(number)))
}

export const updatePrintHistory = (orderId: OrderID | Array<OrderID>) => {
  const printHistory = getPrintHistory()

  if (Array.isArray(orderId)) {
    orderId.forEach(id => addOrderToList(printHistory, id))
  } else {
    addOrderToList(printHistory, orderId)
  }
  setPrintHistory(printHistory)
}

export const sanitizePrintHistory = (existingOrders: string[]) => {
  const printHistory = getPrintHistory()
  const sanitized = printHistory.filter(orderId =>
    existingOrders.includes(orderId)
  )
  setPrintHistory(sanitized)
}

const getNewPrintHistory = () => new Array<string>()

const getPrintHistory = (): Array<string> => {
  const history = localStorage.getItem(PRINT_HISTORY_STORAGE_KEY) ?? '[]'

  try {
    const parsed = JSON.parse(history)
    if (!parsed || !Array.isArray(parsed)) {
      return getNewPrintHistory()
    }
    return parsed
  } catch {
    return getNewPrintHistory()
  }
}

const setPrintHistory = (printHistory: Array<string>) => {
  localStorage.setItem(PRINT_HISTORY_STORAGE_KEY, JSON.stringify(printHistory))
}

const addOrderToList = (printHistory: Array<string>, orderId: OrderID) => {
  const orderString = String(orderId)
  if (!printHistory.includes(orderString)) {
    printHistory.push(orderString)
  }
}
